import { store } from "@/store";
import { App } from "vue";
import { CountriesActionTypes } from "@/core/enums/Countries/Actions";

class Countries{

    public static vueInstance: App;

    public static init(app: App<Element>) {
        Countries.vueInstance = app;
    }

    public static getCountries() {
        store
        .dispatch(CountriesActionTypes.GET_COUNTRIES)
    }

    public static getCountryCode() {
        store
        .dispatch(CountriesActionTypes.GET_COUNTRY_CODE)
    }

    public static getCompanyInfo() {
        store
        .dispatch(CountriesActionTypes.GET_COMPANY_INFO)
    }
}

export default Countries;